type BadgeColor =
  | "gray"
  | "red"
  | "yellow"
  | "green"
  | "blue"
  | "indigo"
  | "purple"
  | "pink";

export default function Badge({
  color,
  text,
}: {
  color: BadgeColor;
  text: string | React.ReactNode;
}) {
  return (
    <>
      {color === "gray" && (
        <span className="inline-flex items-center rounded-full bg-gray-50 px-2 py-1 4k:px-4 4k:py-2 8k:px-8 8k:py-4 1080p:text-lg 4k:text-3xl 8k:text-6xl font-medium text-gray-600 inset-ring inset-ring-gray-500/10">
          {text}
        </span>
      )}
      {color === "red" && (
        <span className="inline-flex items-center rounded-full bg-red-50 px-2 py-1 4k:px-4 4k:py-2 8k:px-8 8k:py-4 1080p:text-lg 4k:text-3xl 8k:text-6xl font-medium text-red-700 inset-ring inset-ring-red-600/10">
          {text}
        </span>
      )}
      {color === "yellow" && (
        <span className="inline-flex items-center rounded-full bg-yellow-50 px-2 py-1 4k:px-4 4k:py-2 8k:px-8 8k:py-4 1080p:text-lg 4k:text-3xl 8k:text-6xl font-medium text-yellow-800 inset-ring inset-ring-yellow-600/20">
          {text}
        </span>
      )}
      {color === "green" && (
        <span className="inline-flex items-center rounded-full bg-green-50 px-2 py-1 4k:px-4 4k:py-2 8k:px-8 8k:py-4 1080p:text-lg 4k:text-3xl 8k:text-6xl font-medium text-green-700 inset-ring inset-ring-green-600/20">
          {text}
        </span>
      )}
      {color === "blue" && (
        <span className="inline-flex items-center rounded-full bg-blue-50 px-2 py-1 4k:px-4 4k:py-2 8k:px-8 8k:py-4 1080p:text-lg 4k:text-3xl 8k:text-6xl font-medium text-blue-700 inset-ring inset-ring-blue-700/10">
          {text}
        </span>
      )}
      {color === "indigo" && (
        <span className="inline-flex items-center rounded-full bg-indigo-50 px-2 py-1 4k:px-4 4k:py-2 8k:px-8 8k:py-4 1080p:text-lg 4k:text-3xl 8k:text-6xl font-medium text-indigo-700 inset-ring inset-ring-indigo-700/10">
          {text}
        </span>
      )}
      {color === "purple" && (
        <span className="inline-flex items-center rounded-full bg-purple-50 px-2 py-1 4k:px-4 4k:py-2 8k:px-8 8k:py-4 1080p:text-lg 4k:text-3xl 8k:text-6xl font-medium text-purple-700 inset-ring inset-ring-purple-700/10">
          {text}
        </span>
      )}
      {color === "pink" && (
        <span className="inline-flex items-center rounded-full bg-pink-50 px-2 py-1 4k:px-4 4k:py-2 8k:px-8 8k:py-4 1080p:text-lg 4k:text-3xl 8k:text-6xl font-medium text-pink-700 inset-ring inset-ring-pink-700/10">
          {text}
        </span>
      )}
    </>
  );
}
